import type { LucideIcon } from 'lucide-react';
import { IconBadge } from '@monksflow/monks-ui';

import { AnalysisMarkdown } from './AnalysisMarkdown';

interface IconBadgeCardProps {
  icon: LucideIcon;
  title: string;
  /** Rendered as markdown, so a passage carrying a citation keeps it. */
  description?: string;
}

/**
 * A bordered card led by its icon, with the title beneath rather than beside it. The shape
 * the redesign uses wherever a section lists named findings: market norms, breakthrough
 * opportunities, cultural signals.
 */
export const IconBadgeCard = ({ icon: Icon, title, description }: IconBadgeCardProps) => (
  <div className="flex h-full flex-col gap-3 rounded-lg border border-border-light p-xl">
    <IconBadge variant="secondary">
      <Icon />
    </IconBadge>
    <div className="flex flex-col gap-2">
      <span className="text-body-xl font-medium text-foreground">{title}</span>
      <AnalysisMarkdown text={description} className="text-body-md text-foreground-alt" />
    </div>
  </div>
);
